document.addEventListener('DOMContentLoaded', () => {

    ///////////////////////////////////////////////////////////////// PRODUCT PAGE START //////////////////////////////////////////////////////////////////////////////
    //Function to implement aria-pressed behavior at product vertical slider at product page
    function initVerticalSliderAria() {

        function initializeOnceReady(container, items) {

            const initialObserver = new MutationObserver(() => {

            const activeItem = container.querySelector('.js-sl-item.is-nav-selected');

            if (activeItem) {

                // apply aria-pressed
                items.forEach(item => {
                const isActive = item.classList.contains('is-nav-selected');
                item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
                });

                // disconect observer
                initialObserver.disconnect();
            }
            });

            // observer inside the container
            initialObserver.observe(container, {
            attributes: true,
            subtree: true,
            attributeFilter: ["class"]
            });
        }

        function tryInitialize() {
            const container = document.querySelector('.col_nav.nav_medium');

            if (!container) {
            return false;
            }

            const items = container.querySelectorAll('.js-sl-item');

            if (!items || items.length === 0) {
            return false;
            }


            // --------------------
            // adaptative observer
            // --------------------
            initializeOnceReady(container, items);

            // interactions
            function activateItem(item) {
            items.forEach(i => {
                i.classList.remove('is-nav-selected');
                i.setAttribute('aria-pressed', 'false');
            });

            item.classList.add('is-nav-selected');
            item.setAttribute('aria-pressed', 'true');
            }

            // click
            items.forEach(item => {
            item.addEventListener('click', () => activateItem(item));
            });

            // keyboard enter
            items.forEach(item => {
            item.addEventListener('keydown', (e) => {
                if (e.key === "Enter") {
                e.preventDefault();
                activateItem(item);
                }
            });
            });

            return true;
        }

        // first try
        if (tryInitialize()) return;

        const bootstrapObserver = new MutationObserver(() => {
            if (tryInitialize()) {
            bootstrapObserver.disconnect();
            }
        });

        bootstrapObserver.observe(document.body, { childList: true, subtree: true });
    }

    //Function to remove product img alt at accessories section in product page
    function initProductImageAltFix() {
        function processImages(container) {
            const imgs = container.querySelectorAll('img:not([data-alt-fixed])');

            imgs.forEach(img => {
                img.setAttribute('alt', '');
                img.setAttribute('data-alt-fixed', 'true');
            });
        }

        // process existing elements
        document.querySelectorAll('.sg-pro-access-product').forEach(processImages);

        // Observe futures changes
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (!(node instanceof HTMLElement)) return;

                    // Si se agrega directamente un contenedor
                    if (node.matches('.sg-pro-access-product')) {
                        processImages(node);
                    }

                    // Si dentro de un nodo agregado existen contenedores
                    const nestedContainers = node.querySelectorAll?.('.sg-pro-access-product');
                    nestedContainers?.forEach(processImages);

                    // También cubre casos donde se agregan IMG directamente
                    if (node.tagName === 'IMG' && node.closest('.sg-pro-access-product')) {
                        processImages(node.closest('.sg-pro-access-product'));
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function add tabIndex 0 to product accessory link 
    function addTabIndexProductAccessoryLink(){
        function processQuickViewLinks(container) {
            const links = container.querySelectorAll('a.sg-pro-access-quick-view-btn:not([data-tabindex-fixed])');

            links.forEach(link => {
                link.setAttribute('tabindex', '0');
                link.setAttribute('data-tabindex-fixed', 'true');
            });
        }

        // Process existing containers 
        document.querySelectorAll('.sg-pro-access-product').forEach(processQuickViewLinks);

        // Lookin for DOM changes
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (!(node instanceof HTMLElement)) return;

                    // Case 1: the added node IS the main container
                    if (node.matches('.sg-pro-access-product')) {
                        processQuickViewLinks(node);
                    }

                    // Case 2: the added node CONTAINS main containers
                    const nestedContainers = node.querySelectorAll?.('.sg-pro-access-product');
                    nestedContainers?.forEach(processQuickViewLinks);

                    // Case 3: the <a> is added directly without its container
                    if (
                        node.tagName === 'A' &&
                        node.classList.contains('sg-pro-access-quick-view-btn')
                    ) {
                        const parent = node.closest('.sg-pro-access-product');
                        if (parent) processQuickViewLinks(parent);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function to add aria-describedby to product accessory quick view link button
    function addAriaDescribedByProductAccessoryQuickViewButton(){
        //counter for IDs
        let uniqueIdCounter = 1;

        function processProductContainer(container) {
            if (!container || container.dataset.sgDescribedbyProcessed) return;
            // Mark container as processed to avoid reprocessing
            container.dataset.sgDescribedbyProcessed = "true";

            // --- 1. Find the product title link ---
            const titleLink = container.querySelector('.sg-pro-access-product-right .sg-pro-access-product-title');
            if (!titleLink) return;

            // Assign ID if missing
            if (!titleLink.id) {
                titleLink.id = `sg-title-${uniqueIdCounter++}`;
            }

            // --- 2. Find all Quick View buttons inside this product ---
            const quickViewLinks = container.querySelectorAll('a.sg-pro-access-quick-view-btn');

            quickViewLinks.forEach(link => {
                // Prevent double processing
                if (link.dataset.sgDescribedbyApplied) return;

                link.setAttribute('aria-describedby', titleLink.id);

                // Mark as processed
                link.dataset.sgDescribedbyApplied = "true";
            });
        }

        // --- Process already existing containers ---
        document.querySelectorAll('.sg-pro-access-product').forEach(container => {
            processProductContainer(container);
        });

        // --- Observe for async additions ---
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (!(node instanceof HTMLElement)) return;

                    // Case 1: node IS the container
                    if (node.matches('.sg-pro-access-product')) {
                        processProductContainer(node);
                    }

                    // Case 2: node contains containers
                    const nestedContainers = node.querySelectorAll?.('.sg-pro-access-product');
                    nestedContainers?.forEach(processProductContainer);

                    // Case 3: Quick View link added alone
                    if (node.matches('a.sg-pro-access-quick-view-btn')) {
                        const parent = node.closest('.sg-pro-access-product');
                        if (parent) processProductContainer(parent);
                    }

                    // Case 4: Title link added alone
                    if (node.matches('.sg-pro-access-product-title')) {
                        const parent = node.closest('.sg-pro-access-product');
                        if (parent) processProductContainer(parent);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function to set focus to Frequently Bought Together title after click Bundle Your Order button
    function redirectFocusToFrenquenlyTittle(){
       const actionButton = document.querySelector('.button1');
       if(!actionButton) return;
       actionButton.addEventListener('click', function() {
        const titleToFocus = document.querySelector('.rebuy-widget-content > .primary-title');
            if (titleToFocus) {
                setTimeout(() => {
                    titleToFocus.setAttribute('tabindex', '-1');
                    titleToFocus.focus();
                    titleToFocus.removeAttribute('tabindex');
                }, 100);
            }
        });
    }

    //Function to add aria-hidden to true to divs with class pr oh
    function applyAriaHiddenTrue(){
        function applyAriaHidden() {
            const items = document.querySelectorAll('.product-image div.pr.oh');
            items.forEach(el => el.setAttribute('aria-hidden', 'true'));
        }

        // Apply to loaded elements
        applyAriaHidden();

        // Observe DOM for changes
        const observer = new MutationObserver(() => {
            applyAriaHidden();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function to upgrade p to h1 in add to cart modal
    function upgradePtoH1(){
        function upgradeToH1() {
            const container = document.querySelector('.added-to-cart');
            if (!container) return;

            const p = container.querySelector('p');
            if (!p || p.tagName === 'H1') return;

            const h1 = document.createElement('h1');
            h1.textContent = p.textContent;

            // Only copy selected visual styles
            const importantStyles = [
                'font-family',
                'font-size',
                'font-weight',
                'line-height',
                'color',
                'margin',
                'padding',
                'text-align',
                'letter-spacing',
                'text-transform'
            ];

            const computed = window.getComputedStyle(p);
            importantStyles.forEach(prop => {
                h1.style[prop] = computed.getPropertyValue(prop);
            });

            p.replaceWith(h1);
        }

        // Run
        upgradeToH1();

        // Handle async popup
        const observer = new MutationObserver(() => upgradeToH1());
        observer.observe(document.body, { childList: true, subtree: true });
    }

    //Function Add AriaLabel to close button
    function AddAriaLabelRemoveTitleModalCloseButton() {
        function protectButton(btn) {
            if (!btn) return;

            const applyFix = () => {
                btn.setAttribute('aria-label', 'close');
                btn.removeAttribute('title');
            };

            applyFix();

            // Prevent multiple observers
            if (btn.__fixed) return;
            btn.__fixed = true;

            // Watch for any attribute change on the button
            const attrObserver = new MutationObserver(() => applyFix());

            attrObserver.observe(btn, {
                attributes: true,
                attributeFilter: ['title', 'aria-label']
            });
        }

        const globalObserver = new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of m.addedNodes) {
                    if (!(node instanceof HTMLElement)) continue;

                    // If the button itself appears
                    if (node.matches('.mfp-close')) {
                        protectButton(node);
                    }

                    // If it appears nested inside a larger injected fragment
                    const nested = node.querySelector?.('.mfp-close');
                    if (nested) {
                        protectButton(nested);
                    }
                }
            }
        });

        globalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function remove tabindex from rating span
    function removeTabIndexFromRatingSpan(){
        const items = document.querySelectorAll('.jdgm-rev__rating');
        if(!items) return;
        items.forEach(element => {
            element.removeAttribute('tabindex');
        });
    }

    //Function to concat stars word next to the end of the rating content
    function nestStartsWord(){
        function processLinks(container = document) {
            const links = container.querySelectorAll("a.jdgm-link");

            links.forEach(link => {
                // Avoid duplicates
                if (link.querySelector(".visually-hidden")) return;

                const span = document.createElement("span");
                span.className = "visually-hidden";
                span.textContent = "stars";

                link.appendChild(span);
            });
        }

        // Process existing items
        processLinks();

        // MutationObserver to check future elements
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (!(node instanceof HTMLElement)) return;

                    // link node
                    if (node.matches?.("a.jdgm-link")) {
                        processLinks(node.parentElement);
                    }

                    // link inside node
                    if (node.querySelectorAll) {
                        processLinks(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //Function to add aria-modal true property to add to cart modal container
    function addAriaModalTrueToModal(){
        const observer = new MutationObserver(() => {
        const popup = document.querySelector('.white-popup.add-to-cart-popup.popup-added_to_cart');
            if (popup) {
                popup.setAttribute('aria-modal', 'true');
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /////// Execution Zone - Product page ///////
    //Validation to prevent execution in not desired pages
    if(window.location.pathname.includes("products")) {
        initVerticalSliderAria();

        initProductImageAltFix();

        addTabIndexProductAccessoryLink();

        addAriaDescribedByProductAccessoryQuickViewButton();

        redirectFocusToFrenquenlyTittle();

        applyAriaHiddenTrue();

        upgradePtoH1();

        AddAriaLabelRemoveTitleModalCloseButton();

        removeTabIndexFromRatingSpan();

        nestStartsWord();

        addAriaModalTrueToModal();
    }


    ///////////////////////////////////////////////////////////////// PRODUCT PAGE END //////////////////////////////////////////////////////////////////////////////



    ///////////////////////////////////////////////////////////////// SALES FORM PAGE START //////////////////////////////////////////////////////////////////////////////
    //Fuction to prevent one shoot read of the form by screens readers at sales form page
    function fixSalesforceGroupReading() {
        function applyCleanGrouping(form) {
            if (!form || form.dataset.a11yFixed === 'true') return;

            const captchaObserver = new MutationObserver(() => {
                const captchaDiv = form.querySelector('.g-recaptcha > div');
                if(captchaDiv) {
                    captchaDiv.setAttribute('aria-hidden', 'false');
                    captchaObserver.disconnect();
                }
            });

            captchaObserver.observe(document.body, {
                subtree: true,
                childList: true
            })

            const labels = Array.from(form.querySelectorAll('label'));

            labels.forEach(label => {
                const fieldId = label.getAttribute('for');
                if (!fieldId) return;

                const field = form.querySelector(`#${fieldId.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1")}`);

                if (field && field.type !== 'hidden') {

                    const groupContainer = document.createElement('div');
                    groupContainer.style.display = 'block';
                    groupContainer.style.marginBottom = '24px';
                    groupContainer.className = 'form-group-clean';

                    label.parentNode.insertBefore(groupContainer, label);

                    groupContainer.appendChild(label);
                    groupContainer.appendChild(field);

                    label.style.display = 'block';
                    label.style.marginBottom = '8px';
                    label.style.fontWeight = 'bold';

                    field.style.display = 'block';
                    field.style.width = '100%';
                    field.style.padding = '8px';
                    field.style.boxSizing = 'border-box';
                }
            });

            const allNodes = Array.from(form.childNodes);
            allNodes.forEach(node => {
                const isGroup = node.classList && node.classList.contains('form-group-clean');
                const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
                const isSubmit = node.id === 'submitBtn' || (node.tagName === 'INPUT' && node.type === 'submit');
                const isRecaptcha = node.classList && node.classList.contains('g-recaptcha');

                if (!isGroup && !isHiddenInput && !isSubmit && !isRecaptcha && node.tagName !== 'SCRIPT') {
                    node.remove();
                }
            });

            const submitBtn = form.querySelector('#submitBtn, input[type="submit"]');
            if (submitBtn) {
                submitBtn.style.display = 'block';
                submitBtn.style.marginTop = '20px';
            }

            form.dataset.a11yFixed = 'true';
        }

        const ROOT_SELECTOR = '.code_setting';
        const root = document.querySelector(ROOT_SELECTOR);
        if (!root) return;

        const observer = new MutationObserver(() => {
            const form = root.querySelector('form');
            if (form) {
                applyCleanGrouping(form);
                observer.disconnect();
            }
        });

        observer.observe(root, {
            childList: true,
            subtree: true
        });

        const initialForm = root.querySelector('form');
        if (initialForm) {
            applyCleanGrouping(initialForm);
        }
    }
    // function to add correct autocomplete value for each input  in the sales form
    function addAutoCompleteToSalesFormItems(){
        function enableAutocomplete(form) {
            if (!form || form.dataset.autocompleteFixed === 'true') return;
            form.dataset.autocompleteFixed = 'true';

            // Nombre
            const nameInput = form.querySelector('input[name="name"]');
            if (nameInput) {
            nameInput.setAttribute('autocomplete', 'name');
            }

            // Email
            const emailInput = form.querySelector('input[name="email"]');
            if (emailInput) {
            emailInput.setAttribute('autocomplete', 'email');
            emailInput.setAttribute('inputmode', 'email');
            }

            // Teléfono
            const phoneInput = form.querySelector('input[name="phone"]');
            if (phoneInput) {
            phoneInput.setAttribute('autocomplete', 'tel');
            phoneInput.setAttribute('inputmode', 'tel');
            }

            // Descripción (mejor desactivarlo)
            const description = form.querySelector('textarea[name="description"]');
            if (description) {
            description.setAttribute('autocomplete', 'off');
            }

            // Selects de negocio → off
            form.querySelectorAll('select').forEach(select => {
            select.setAttribute('autocomplete', 'off');
            });
        }

        // Init
        const form = document.querySelector('form[action*="WebToCase"]');
        if (form) enableAutocomplete(form);

        // Por si Salesforce o scripts reinyectan el form
        const observer = new MutationObserver(() => {
            const form = document.querySelector('form[action*="WebToCase"]');
            if (form) enableAutocomplete(form);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /////// Execution Zone - Sales form page ///////
    //Validation to prevent execution in not desired pages
    if(window.location.pathname.includes("sales-form")) {
        fixSalesforceGroupReading();
        addAutoCompleteToSalesFormItems();
    }
    ///////////////////////////////////////////////////////////////// SALES FORM PAGE END //////////////////////////////////////////////////////////////////////////////


    

    ///////////////////////////////////////////////////////////////// SERVICES PAGE START ////////////////////////////////////////////////////////////////////////////////
    //function to solve the issue about one shot read in the services form
    function fixServicesforceGroupReading() {
        const ROOT_SELECTOR = '.code_setting';
        const root = document.querySelector(ROOT_SELECTOR);
        if (!root) return;

        function applyA11yStyles(form) {
            if (!form || form.dataset.styleFixed === 'true') return;

            const captchaObserver = new MutationObserver(() => {
                const captchaDiv = form.querySelector('.g-recaptcha > div');
                if(captchaDiv) {
                    captchaDiv.setAttribute('aria-hidden', 'false');
                    captchaObserver.disconnect();
                }
            });

            captchaObserver.observe(document.body, {
                subtree: true,
                childList: true
            })

            form.querySelectorAll('br').forEach(br => br.remove());

            form.querySelectorAll('label').forEach(label => {
                label.style.display = 'block';
                label.style.marginBottom = '5px';
                label.style.fontWeight = 'bold';
                label.style.marginTop = '15px';
            });

            const fields = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
            fields.forEach(field => {
                field.style.display = 'block';
                field.style.width = '100%';
                field.style.padding = '8px';
                field.style.marginBottom = '10px';
                field.style.boxSizing = 'border-box';
            });

            const brandSelect = form.querySelector('select[name="00N3k00000J56dl"]');
            if (brandSelect && brandSelect.previousSibling && brandSelect.previousSibling.nodeType === 3) {
                if (brandSelect.previousSibling.textContent.includes('Brand:')) {
                    brandSelect.previousSibling.textContent = '';
                }
            }

            const note = form.querySelector('#note_address');
            if (note) {
                note.style.display = 'block';
                note.style.margin = '15px 0';
                note.style.fontSize = '0.9em';
                note.style.color = '#555';
            }

            const submitBtn = form.querySelector('#submitBtn');
            if (submitBtn) {
                submitBtn.style.display = 'block';
                submitBtn.style.marginTop = '20px';
                submitBtn.style.padding = '10px 25px';
            }

            form.dataset.styleFixed = 'true';
        }

        const observer = new MutationObserver(() => {
            const form = root.querySelector('form');
            if (form && form.dataset.styleFixed !== 'true') {
                applyA11yStyles(form);
                observer.disconnect();
            }
        });

        observer.observe(root, { childList: true, subtree: true });

        const initialForm = root.querySelector('form');
        if (initialForm) applyA11yStyles(initialForm);
    }
    // function to add correct autocomplete value for each input in the service form
    function addAutoCompleteToServiceFormItems() {
        const autocompleteMap = {
        name: 'name',
        email: 'email',
        phone: 'tel',
        '00N3k00000J55PT': 'street-address',
        '00N3k00000J55Pn': 'address-level2',
        '00N3k00000J55Pi': 'address-level1',
        '00N3k00000J55Px': 'postal-code',
        '00N3k00000J55Q2': 'country'
        };

        const observer = new MutationObserver(() => {
            const form = document.querySelector('form[aria-label="Service"]');
            if (!form) return;

            Object.entries(autocompleteMap).forEach(([id, value]) => {
            const input = form.querySelector(`#${CSS.escape(id)}`);
            if (input && !input.hasAttribute('autocomplete')) {
                input.setAttribute('autocomplete', value);
            }
            });

            const description = form.querySelector('textarea[name="description"]');
            if (description) {
            description.setAttribute('autocomplete', 'off');
            }

            // ✅ Trabajo terminado → desconectamos
            observer.disconnect();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }



    /////// Execution Zone - Sales form page ///////
    //Validation to prevent execution in not desired pages
    if(window.location.pathname.includes("service")) {
        fixServicesforceGroupReading();
        addAutoCompleteToServiceFormItems();
    }
    ///////////////////////////////////////////////////////////////// SERVICES PAGE END //////////////////////////////////////////////////////////////////////////////


    ///////////////////////////////////////////////////////////////// kitchen-packages PAGE START //////////////////////////////////////////////////////////////////////////////
    /*
    function triggerFakeResize() {
        requestAnimationFrame(() => {
            console.log('recize')
            window.dispatchEvent(new Event('resize'));
        });
    }

    function setupEventListeners() {
        document.addEventListener('click', e => {
            const dot = e.target.closest('.flickity-page-dots .dot span');
            if (!dot) return;

            triggerFakeResize();
        });

        document.addEventListener('keydown', e => {
        const dot = e.target.closest('.flickity-page-dots .dot span');
        if (!dot) return;

        if (e.key === 'Enter' || e.key === ' ') {
            triggerFakeResize();
        }
    }


    
    if(window.location.pathname.includes("kitchen-packages")) {
        //reCallFlickerViewPort();
        triggerFakeResize();
        setupEventListeners();
    }*/
    ///////////////////////////////////////////////////////////////// kitchen-packages PAGE END //////////////////////////////////////////////////////////////////////////////

    ////// Global /////
    //function to add described by to re buy items
    function addDescribedByToRebuyItemsCheckbox(){
        const PRICE_ID_PREFIX = 'rebuy-price-desc-';

        function applyRebuyAriaFix() {
            const productInfos = document.querySelectorAll('.rebuy-product-info');

            if (!productInfos.length) return false;

            productInfos.forEach((product, index) => {
            const priceWrapper = product.querySelector('.rebuy-product-price > div');
            const checkboxInput = product.querySelector(
                '.rebuy-product-checkbox input[type="checkbox"]'
            );

            if (!priceWrapper || !checkboxInput) return;

            if (priceWrapper.id) {
                checkboxInput.setAttribute('aria-describedby', priceWrapper.id);
                return;
            }

            const priceId = `${PRICE_ID_PREFIX}${index}`;

            priceWrapper.id = priceId;
            checkboxInput.setAttribute('aria-describedby', priceId);
            });

            return true;
        }

        if (applyRebuyAriaFix()) return;

        const observer = new MutationObserver(() => {
            const applied = applyRebuyAriaFix();

            if (applied) {
            observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //function to add tabIndex -1 to every read more button in recently view products
    function addTabIndexMinusToReadMoreButton(){
        const TARGET_SELECTOR = 'a.pr_atc.read-more';
        const FIX_ATTR = 'data-read-more-tabindex-fixed';

        function applyFix(root = document) {
            let applied = false;

            root.querySelectorAll(TARGET_SELECTOR).forEach(el => {
            const text = el.textContent?.toLowerCase() || '';
            const aria = el.getAttribute('aria-label')?.toLowerCase() || '';

            if (!text.includes('read more') && !aria.includes('read more')) return;

            if (el.getAttribute('tabindex') !== '-1') {
                el.setAttribute('tabindex', '-1');
                el.setAttribute(FIX_ATTR, 'true');
                applied = true;
            }
            });

            return applied;
        }

        applyFix();

        const observer = new MutationObserver(mutations => {
            let shouldReapply = false;

            for (const mutation of mutations) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'tabindex' &&
                mutation.target.matches?.(TARGET_SELECTOR)
            ) {
                shouldReapply = true;
                break;
            }

            if (mutation.type === 'childList' && mutation.addedNodes.length) {
                shouldReapply = true;
                break;
            }
            }

            if (shouldReapply) {
            applyFix();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['tabindex']
        });

        let stableTicks = 0;
        const MAX_STABLE_TICKS = 10;

        const stabilityCheck = setInterval(() => {
            const unfixed = document.querySelector(
            `${TARGET_SELECTOR}:not([tabindex="-1"])`
            );

            if (!unfixed) {
            stableTicks++;
            } else {
            stableTicks = 0;
            }

            if (stableTicks >= MAX_STABLE_TICKS) {
            observer.disconnect();
            clearInterval(stabilityCheck);
            }
        }, 300);
    }

    //function to expandable semantics to the specifications accordion items
    function addRoleAndExpandableSemanticsToEspecificationsAccordionItems(){
        const PANEL_SELECTOR = '.panel.entry-content.sp-tab';
        const LINK_SELECTOR = '.heading a';
        const INIT_ATTR = 'data-aria-sync-init';

        function syncAria(panel) {
            const trigger = panel.querySelector(LINK_SELECTOR);
            if (!trigger) return;

            const isActive = panel.classList.contains('active');
            trigger.setAttribute('aria-expanded', String(isActive));
        }

        function setupPanel(panel) {
            const trigger = panel.querySelector(LINK_SELECTOR);
            if (!trigger) return;

            if (trigger.hasAttribute(INIT_ATTR)) return;
            trigger.setAttribute(INIT_ATTR, 'true');

            trigger.setAttribute('role', 'button');
            trigger.setAttribute('aria-expanded', 'false');

            syncAria(panel);

            const classObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                syncAria(panel);
                }
            });
            });

            classObserver.observe(panel, {
            attributes: true,
            attributeFilter: ['class']
            });
        }

        function init(root = document) {
            root.querySelectorAll(PANEL_SELECTOR).forEach(setupPanel);
        }

        init();

        const globalObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.matches?.(PANEL_SELECTOR)) {
                setupPanel(node);
                }

                node.querySelectorAll?.(PANEL_SELECTOR).forEach(setupPanel);
            });
            });
        });

        globalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //function to add aria pressed to ranking buttons 
    function addAriaPressedToRankings(){
        const ROW_SELECTOR = '.jdgm-histogram__row';
        const INIT_ATTR = 'data-aria-pressed-init';

        function syncAria(row) {
            const isSelected = row.classList.contains('jdgm-histogram__row--selected');
            row.setAttribute('aria-pressed', String(isSelected));
        }

        function setupRow(row) {
            if (row.hasAttribute(INIT_ATTR)) return;
            row.setAttribute(INIT_ATTR, 'true');

            row.setAttribute('role', 'button');
            row.setAttribute('aria-pressed', 'false');

            syncAria(row);

            const classObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                syncAria(row);
                }
            });
            });

            classObserver.observe(row, {
            attributes: true,
            attributeFilter: ['class']
            });
        }

        function init(root = document) {
            root.querySelectorAll(ROW_SELECTOR).forEach(setupRow);
        }

        init();

        const globalObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.matches?.(ROW_SELECTOR)) {
                setupRow(node);
                }

                node.querySelectorAll?.(ROW_SELECTOR).forEach(setupRow);
            });
            });
        });

        globalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    //function to solve correct item focus at search bar
    function solveKeyboardFocus(){
        if(window.innerWidth <= 768) {
            const UL_SELECTOR = 'ul.boost-sd__instant-search-product-list-items';

            function applyRoleToItems(ul) {
                const items = ul.querySelectorAll('li');

                if (!items.length) return false;

                items.forEach(li => {
                if (!li.hasAttribute('role')) {
                    li.setAttribute('role', 'option');
                }
                });

                return true;
            }

            function observeAsync() {
                const ul = document.querySelector(UL_SELECTOR);

                if (ul && applyRoleToItems(ul)) {
                return;
                }

                const observer = new MutationObserver(() => {
                const ul = document.querySelector(UL_SELECTOR);
                if (!ul) return;

                const applied = applyRoleToItems(ul);
                if (applied) {
                    observer.disconnect();
                }
                });

                observer.observe(document.body, {
                childList: true,
                subtree: true
                });
            }

            observeAsync();
        }
    }

    //function to prevent read by NVDA to close and back buttons at search bar
    function preventReadCloseAndBackButtons(){
        
        const SELECTORS = [
            '.boost-sd__button-text-x--clear',
            '.boost-sd__button-text-x--close'
        ];

        function apply(root = document) {
            root.querySelectorAll(SELECTORS.join(',')).forEach(el => {
            //el.setAttribute('inert', '');
            //el.setAttribute('aria-hidden', 'true');
            //el.setAttribute('tabindex', '-1');
            });
        }

        apply();

        const observer = new MutationObserver(mutations => {
            for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node.nodeType === 1) apply(node);
            }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /////Global execution zone 
    addDescribedByToRebuyItemsCheckbox();
    addTabIndexMinusToReadMoreButton();
    addRoleAndExpandableSemanticsToEspecificationsAccordionItems();
    addAriaPressedToRankings();
    solveKeyboardFocus();
    preventReadCloseAndBackButtons();
    ///////////////////
});